import {
  Component,
  ComponentInterface,
  h,
  Prop,
} from '@stencil/core';

@Component({
  shadow: true,
  styleUrl: 'paf-notification.scss',
  tag: 'paf-notification',
})

export class PafNotification implements ComponentInterface {

  /**
   * The title for the notification
  */
  @Prop() public titleText!: string;

  /**
   * The html content to show
  */
  @Prop() public content!: string;

  /**
   * The title level for the title of the notification
   */
  @Prop() public titleLevel!: number;

  public render(): HTMLDivElement {
    const TITLE_TAG = `h${this.titleLevel}`;

    return (
      <div class='notification'>
        <svg class='icon' viewBox='0 0 48 48'><path d='M6 40.004h2V48H6v-7.996ZM20 48h2v-8h-2v8ZM7 20a7 7 0 1 1 14 0 7 7 0 0 1-14 0Zm2 0c0 2.757 2.243 5 5 5s5-2.243 5-5-2.243-5-5-5-5 2.243-5 5Zm39-9c0 6.06-5.84 11-13 11a15.143 15.143 0 0 1-1.56 0L22 25.72l3.6-7.14A10.2 10.2 0 0 1 22 11c0-6 5.84-11 13-11s13 4.94 13 11Zm-2 0c0-4.963-4.935-9-11-9-5.963 0-11 4.121-11 9a8.185 8.185 0 0 0 2.894 6.055l1.201 1.019-.71 1.406-1.438 2.853 6.875-2.235.352-.115.37.02a13.034 13.034 0 0 0 1.352 0l.052-.003H35c6.065 0 11-4.037 11-9Zm-9.507-1h-4v1h.992v3.989h-.992v1H37.5v-1h-.996L36.493 10Zm-1.494-1.24a1.76 1.76 0 1 0 0-3.52 1.76 1.76 0 0 0 0 3.52ZM20.98 29.96H7.02C3.159 29.96 0 33.119 0 36.98V48h2V36.98a5.025 5.025 0 0 1 5.02-5.02h13.96A5.025 5.025 0 0 1 26 36.98V48h2V36.98c0-3.861-3.159-7.02-7.02-7.02Z'/></svg>

        <div>
          <TITLE_TAG class='title'>{this.titleText}</TITLE_TAG>
          <div
            class='content'
            innerHTML={this.content}
          />
        </div>
      </div>
    );
  }
}
